import React from 'react';
import {
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  Label,
  FormGroup
} from 'reactstrap';
import '../../assets/css/InputFormStyle.css';


const CompanyMultiTextInput = (props) => {
  const { label, inputList, updateInputList } = props;

  const onInputChange = (e, index) => {
    const list = [...inputList];
    list[index] = e.target.value;
    updateInputList(list);
  };

  const onRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    updateInputList(list);
  };

  const onAddClick = () => {
    updateInputList([...inputList, '']);
  };

  return (
    <FormGroup>
      <Label for="multi_input_text">{label}</Label>
      <Button
        outline 
        color="primary" 
        size="sm" className="button-add-product"
        onClick={() => onAddClick()}>
        <i className="fa fa-plus-square" />
      </Button>
      {inputList.map((value, i) =>
        <InputGroup
          key={"multi_text_input_group" + i}
          id={"multi_text_input_group" + i}
          className="product-input-group">
          <Input
            type="text"
            key={"multi_text_input_" + i}
            name={"multi_text_input_" + i}
            id={"multi_text_input_" + i}
            value={value}
            onChange={e => onInputChange(e, i)}
            className="product-input-text"/>
          <InputGroupAddon addonType="append">
            <Button close size="sm" onClick={() => onRemoveClick(i)} />
          </InputGroupAddon>
        </InputGroup>
      )}
    </FormGroup>
  );
}

export default CompanyMultiTextInput;
